import React from 'react';
import {
  FDBodyText, FDClickableText, FDDialog, FDDialogContent, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import InvestingDetailsChart
  from 'Views/Page/Content/Modal/Layouts/ScenarioSelectionAssumptionsAndDetails/Layout/RoadmapDeliverableInvestingDetailsPicker/RoadmapDeliverableInvestingDetails/InvestingDetailsChart';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

const RoadmapDeliverableInvestingDetailsLayout = () => {
  const { resource } = useMetaLayoutContext();
  const charts = resource.attr('charts').resources().list();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogText, setDialogText] = React.useState('');
  return (
    <FDStack direction={'column'} spacing={3.5} paddingY={2}>
      <FDStack direction={'column'} spacing={6}>
        {
          charts.map((chart, i) => {
            return <InvestingDetailsChart key={chart.id()} resource={chart} isLastChart={i === (charts.length - 1)} />;
          })
        }
      </FDStack>
      <FDStack direction={'column'} spacing={3.5}>
        {
          charts.map((chart) => {
            return (
              <FDStack direction={'column'}>
                <Richtext key={chart.id()} richtext Component={FDBodyText} size={'sm'} align={'center'} color={'textDisabled'} value={chart.attr('disclaimer')} />
                {chart.attr('disclaimerLinkText')
                  ? <FDBodyText
                    size={'sm'}
                    color={'textDisabled'}
                    align={'center'}
                    value={
                      <FDClickableText
                        appearance={'standalone'}
                        label={chart.attr('disclaimerLinkText')}
                        onClick={() => { setDialogOpen(true); setDialogText(chart.attr('disclaimerLinkContent')); }}
                      />
                      }
                  />
                  : null}
              </FDStack>
            );
          })
        }
      </FDStack>
      {
        dialogOpen ? (
          <FDDialog open={dialogOpen} onClose={() => setDialogOpen(false)} closeOnBackdropClick dialogWidth={'md'} noCloseButton={false}>
            <FDDialogContent>
              <Richtext richtext Component={FDBodyText} size={'md'} value={dialogText} />
            </FDDialogContent>
          </FDDialog>)
          : null
      }
    </FDStack>
  );
};

RoadmapDeliverableInvestingDetailsLayout.defaultProps = {};

RoadmapDeliverableInvestingDetailsLayout.propTypes = {};

export default RoadmapDeliverableInvestingDetailsLayout;
